import React from "react";

function AgriculturePlaceHolderIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="59"
      fill="none"
      viewBox="0 0 50 59"
    >
      <rect
        width="49.105"
        height="58.584"
        y="0.037"
        fill="#1C64F2"
        fillOpacity="0.08"
        rx="8"
      ></rect>
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M24.043 20.785h.444c3.118 0 4.677 0 5.268.668.512.578.738 1.428.6 2.252-.16.953-1.432 2.027-3.977 4.175l-4.158 3.509c-2.546 2.147-3.818 3.221-3.978 4.174-.138.824.089 1.674.6 2.252.592.668 2.15.668 5.268.668h.956m-4.604-17.697c0 2.022-1.374 3.661-3.069 3.661-1.695 0-3.069-1.64-3.069-3.662 0-2.022 1.374-3.661 3.07-3.661 1.694 0 3.068 1.64 3.068 3.662zm14.323 17.087c0 2.022-1.374 3.661-3.07 3.661-1.694 0-3.068-1.64-3.068-3.661 0-2.023 1.374-3.662 3.069-3.662 1.695 0 3.069 1.64 3.069 3.662z"
      ></path>
    </svg>
  );
}

export default AgriculturePlaceHolderIcon;
